import { css } from "styled-components";

import { Icon } from "../Button.types";

export const getIconVariant = (icon: Icon) => css`
  ${icon === "alone" &&
  css`
    --button-padding-h: var(--button-padding-v);
  `}
`;
